module.exports = __webpack_public_path__ + "static/media/jardinage2.b0688780.jpg";